/** 资格声明敏感写入不离线排队，不自动重放；未知结果须重新读取真实状态。 */
import type { UsdCoverageResponse } from '@novel-admin/shared/schemas/usd-coverage';
import { onlineManager, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiRequest, apiRequestOffsetPaged } from '~/api/client';
export const USD_COVERAGE_QUERY_KEY = ['usd-coverage'] as const;
export function assertCoverageOnline() {
  if (!onlineManager.isOnline()) throw new Error('当前离线，请联网后重新确认操作');
}
export const usdCoverageApi = {
  list: (appId: string, page: number) =>
    apiRequestOffsetPaged<UsdCoverageResponse>({
      method: 'GET',
      path: '/api/v1/metrics/usd-coverage',
      query: { ...(appId === 'all' ? {} : { app_id: appId }), page, limit: 50 },
    }),
  write: async (input: {
    appId: string;
    operation: 'declare' | 'verify' | 'revoke';
    coveredSince?: string;
  }) => {
    assertCoverageOnline();
    return apiRequest<UsdCoverageResponse>({
      method:
        input.operation === 'declare' ? 'PUT' : input.operation === 'verify' ? 'POST' : 'DELETE',
      path: `/api/v1/metrics/usd-coverage/${input.appId}${input.operation === 'verify' ? '/verify' : ''}`,
      body: input.operation === 'declare' ? { covered_since: input.coveredSince } : {},
      replayOnUnauthorized: false,
      timeoutMs: 30000,
    });
  },
};
export function useUsdCoverage(appId: string, page: number) {
  return useQuery({
    queryKey: [...USD_COVERAGE_QUERY_KEY, appId, page],
    queryFn: () => usdCoverageApi.list(appId, page),
    retry: false,
  });
}
export function useUsdCoverageWrite() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: usdCoverageApi.write,
    networkMode: 'always',
    retry: false,
    onSettled: () => client.invalidateQueries({ queryKey: USD_COVERAGE_QUERY_KEY }),
  });
}
